import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import '@/utils/mixins';
import '@/assets/scss/styles.scss';
import VeeValidate, { Validator } from 'vee-validate';
import ja from 'vee-validate/dist/locale/ja';
import Paginate from 'vuejs-paginate';
import { BootstrapVue, BTooltip as bTooltip } from 'bootstrap-vue';
import linkify from 'vue-linkify';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import ToggleButton from 'vue-js-toggle-button';

Vue.use(ToggleButton);

Vue.component('b-tooltip', bTooltip);

Vue.component('vue-paginate', Paginate);

Vue.config.productionTip = false;
// VeeValidate.Validator.localize('en', {
//   custom: {
//     confirm_password: {
//       confirmed: 'Does not match with password field.',
//     },
//     new_password: {
//       required: 'New password field is required.',
//       min: (fieldName, params) => `New password must be at least ${params} characters.`,
//     },
//     current_password: {
//       required: 'Current password field is required.',
//     },
//   },
// });
Vue.directive('linkified', linkify);
Vue.use(VeeValidate, {
  errorBagName: 'formErrors',
  fieldsBagName: 'Vfields',
  delay: 500,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
  classes: true,
});

VeeValidate.Validator.extend('alhpanum_upper_lower_special', {
  getMessage: (field) =>
    `${field} must contain one uppercase ,one lowecase, one number and one special character.`,
  validate: (value) => {
    //"^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})"
    var strongRegex = new RegExp(
      /^(?=.*\d)(?=.*[!@#$%^&*"'()+,-./:;<=>?[\\\]_`{|}~])(?=.*[a-z])(?=.*[A-Z]).{8,}$/
    );
    return strongRegex.test(value);
  },
});

Validator.localize('ja', ja);
Validator.localize('ja', {
  custom: {
    password: {
      alhpanum_upper_lower_special:
        'パスワードを正しく設定してください。' +
        '\n文字の種類(大文字アルファベット、小文字アルファベット、数字、記号)をそれぞれ1文字以上含め、' +
        '\n8文字以上のパスワードを設定する必要があります。例: @Aa12345',
    },
    new_password: {
      alhpanum_upper_lower_special:
        'パスワードを正しく設定してください。' +
        '\n文字の種類(大文字アルファベット、小文字アルファベット、数字、記号)をそれぞれ1文字以上含め、' +
        '\n8文字以上のパスワードを設定する必要があります。例: @Aa12345',
    },
    email: {
      required: 'メールアドレスは必須項目です',
      email: 'メールアドレスは必須項目です',
    },
  },
});

Vue.use(BootstrapVue);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
